import React from "react";



interface IframeworkRetriggerPopup {
    data: {
        COMPONENTS: any
    }

}

export const frameworkRetriggerPopup: IframeworkRetriggerPopup = {

    data: {
        "COMPONENTS": [
            {
                "id": "RetriggerPopupMainContainer",
                "name": "RetriggerPopupMainContainer",
                "type": "Container",
                "x": 0,
                "y": 0,
                "visible": true,
                "filterTypes": [],
                child: [
                    {
                        "name": "Retrigger_Graphic1",
                        "type": "Graphic",
                        "shape": "rectangle",
                        "visible": false,

                        "alpha": 0.4,
                        "group": "Intro",
                        "color": "0x000000",
                        "x": 0,
                        "y": 0,
                        "width": 1920,
                        "height": 1080,
                    },
                    {
                        "id": "popupContainer",
                        "name": "popupContainer",
                        "type": "Container",
                        "x": 0,
                        "y": 0,
                        "visible": false,

                        "filterTypes": [],
                        child: [
                            /*     {
                                    "name": "Retrigger_Graphic",
                                    "type": "Graphic",
                                    "shape": "rectangle",
                                    "visible": true,
                                    "alpha": 0.001,
                                    "color": "0x000000",
                                    "layout": true,
                                    "x": 0,
                                    "y": 0,
                                    "width": 1920,
                                    "height": 1080,
    
                                },
     */


                            {
                                "name": "introBg_desktop1",
                                "image": "introBG",
                                "type": "Image",
                                "class": "",
                                "layout": false,
                                "uimode": "desktop",
                                "visible": true,
                                "interactive": false,
                                "buttonMode": false,
                                "group": "Intro",
                                "width": 1078,
                                "height": 921,
                                "anchor": [0.5, 0.5],
                                "x": 940,
                                "y": 520,
                            },
                            {
                                "id": "reTrigger_Congratulation",
                                "name": "reTrigger_Congratulation_desktop",
                                "type": "Text",
                                "x": 940,
                                "y": 340,
                                "visible": true,
                                "layout": false,
                                "uimode": "desktop",
                                "text": "congrats",
                                "width": 2440,
                                "height": 600,
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 105,
                                    fontStyle: 'bold',
                                    fill: ['#efe457', '#feae31'],
                                    dropShadow: true,
                                    letterSpacing: 5,
                                    dropShadowColor: '#000000',
                                    dropShadowBlur: 4,
                                    dropShadowAngle: Math.PI / 2,
                                    dropShadowDistance: 6,


                                }
                            },


                            {
                                "id": "reTrigger_count_retrigger",
                                "name": "reTrigger_count_retrigger",
                                "type": "Text",
                                "x": 955,
                                "y": 610,
                                "visible": true,
                                "layout": false,
                                "uimode": "desktop",
                                "text": "10",
                                "width": 1200,
                                "height": 200,
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 200,
                                    fontStyle: 'bold',
                                    fill: ['#ffffff', '#ededed'],
                                    dropShadow: true,
                                    dropShadowColor: '#000000',
                                    dropShadowBlur: 2,
                                    dropShadowAngle: Math.PI / 2,
                                    dropShadowDistance: 6,


                                }
                            },

                            {
                                "id": "reTrigger_freespintext",
                                "name": "reTrigger_freespintext_desktop",
                                "type": "Text",
                                "x": 955,
                                "y": 750,
                                "visible": true,
                                "layout": false,
                                "uimode": "desktop",
                                "text": "Additional Free Spins",
                                "width": 1800,
                                "height": 200,
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 70,
                                    fontStyle: 'bold',
                                    fill: ['#efe457', '#feae31'],
                                    dropShadow: true,
                                    dropShadowColor: '#000000',
                                    dropShadowBlur: 2,
                                    dropShadowAngle: Math.PI / 2,
                                    dropShadowDistance: 6,


                                }
                            },

                            {
                                "id": "reTrigger_you",
                                "name": "reTrigger_you_desktop",
                                "type": "Text",
                                "x": 955,
                                "y": 470,
                                "visible": true,
                                "text": "youve",
                                "layout": false,
                                "uimode": "desktop",
                                "width": 1200,
                                "height": 200,
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'impact',
                                    fontSize: 70,
                                    fontStyle: 'bold',
                                    fill: ['#efe457', '#feae31'],
                                    dropShadow: true,
                                    letterSpacing: 3,
                                    dropShadowColor: '#000000',
                                    dropShadowBlur: 2,
                                    dropShadowAngle: Math.PI / 2,
                                    dropShadowDistance: 6,


                                }
                            },

                            /*   {
                                  "id": "fg_intro_clickAnywhereText",
                                  "name": "fg_intro_clickAnywhereText_desktop",
                                  "type": "Text",
                                  "x": 955,
                                  "y": 830,
                                  "visible": true,
                                  "layout": false,
                                  "uimode": "desktop",
                                  "text": "introtext_5",
                                  "width": 1000,
                                  "height": 200,
                                  "scaleToFit": true,
                                  "anchor": [0.5, 0.5],
                                  "textStyle": {
                                      fontFamily: 'Arial',
                                      fontSize: 32,
                                      fontStyle: 'bold',
                                      fill: ['#ffffff'],
                                      dropShadow: true,
                                      dropShadowColor: '#000000',
                                      dropShadowBlur: 2,
                                      dropShadowAngle: Math.PI / 2,
                                      dropShadowDistance: 6,
  
  
                                  }
                              }, */

                        ]
                    },

                ]
            },

        ]
    }

};

export const RetriggerPopupConfigurationContext = React.createContext(
    {}
);